import * as React from 'react';
import { hashHistory } from 'react-router';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import hoistNonReactStatics from 'js/lib/hoistNonReactStatics';
import user from 'js/lib/user';

import Button from 'bundles/coursera-ui/components/basic/Button';

/**
 * A simple HOC to add LoginModal if user is not already logged in
 */
type Props = {
  // Original propType: object.isRequired
  loggedOutBtnAttributes?: $TSFixMe;
  // Original propType: object
  loginRouterParams?: $TSFixMe;
  loginHashHistoryReplacement?: string;
  renderNothingIfLoggedOut?: boolean;
};

const withLogin = (Component: $TSFixMe): $TSFixMe => {
  const componentName = Component.displayName || Component.name;

  class HOC extends React.Component<Props> {
    static displayName = `withLogin(${componentName})`;

    static contextTypes = {
      router: PropTypes.object.isRequired,
    };

    declare context: LegacyContextType<typeof HOC.contextTypes>;

    static defaultProps = {
      loggedOutBtnAttributes: {
        type: 'primary',
      },
      loginRouterParams: {},
    };

    handleClick = () => {
      const { loginRouterParams, loginHashHistoryReplacement } = this.props;

      const router = this.context.router;
      const newQueryParams = {
        ...router.location.query,
        authMode: 'login',
        ...loginRouterParams,
      };
      router.push({
        pathname: router.location.pathname,
        params: router.params,
        query: newQueryParams,
      });
      if (loginHashHistoryReplacement) {
        hashHistory.replace(loginHashHistoryReplacement);
      }
    };

    render() {
      const { loggedOutBtnAttributes, renderNothingIfLoggedOut, ...rest } = this.props;
      const isAuthenticated = user.get().authenticated;
      if (!isAuthenticated) {
        return renderNothingIfLoggedOut ? null : <Button {...loggedOutBtnAttributes} onClick={this.handleClick} />;
      }

      return <Component {...rest} />;
    }
  }

  hoistNonReactStatics(HOC, Component);
  return HOC;
};

export default withLogin;
